import type { CityConfig } from "../city-template/types";

export const stillwaterConfig: CityConfig = {
  city: "Stillwater",
  state: "Oklahoma",
  stateAbbr: "OK",
  slug: "stillwater",
  route: "/cities/stillwater",
  title: "Emergency Passport Stillwater, OK | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Stillwater, OK — as fast as 24 hours. Serving OSU students, faculty, and North Central Oklahoma. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Stillwater, OK",
  heroSubtitle: "OSU study abroad program to Spain leaving in two weeks? Business trip to Tokyo and your passport is expired? Spring break in Cabo with friends but no valid documents? We help Stillwater Cowboys and North Central Oklahoma residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Oklahoma%20State%20University%20campus%20Stillwater%20Oklahoma%20orange%20brick%20buildings%20Edmon%20Low%20Library%20Old%20Central%20the%20iconic%20Theta%20Pond%20with%20fountain%20green%20campus%20lawn%20autumn%20colors%20football%20stadium%20Boone%20Pickens%20golden%20warm%20afternoon%20light%20professional%20drone%20photography&width=1800&height=700&seq=stillwater-ok-hero-2026&orientation=landscape",
  heroImageAlt: "Oklahoma State University campus Stillwater with Edmon Low Library at golden hour",
  geoPosition: "36.1156;-97.0589",
  geoPlacename: "Stillwater, Oklahoma",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "1100 Commerce Street, Suite 900, Dallas, TX 75242",
    distance: "Located in downtown Dallas — approximately 290 miles south of Stillwater via I-35",
  },
  nearbyCitiesZips: [
    { name: "Stillwater", zips: "74074, 74075, 74076" },
    { name: "Perry", zips: "73077" },
    { name: "Cushing", zips: "74023" },
    { name: "Ponca City", zips: "74601, 74602, 74604" },
    { name: "Guthrie", zips: "73044" },
    { name: "Edmond", zips: "73003, 73012, 73013" },
    { name: "Oklahoma City", zips: "73102, 73103" },
    { name: "Blackwell", zips: "74631" },
    { name: "Tonkawa", zips: "74653" },
    { name: "Morrison", zips: "73061" },
    { name: "Glencoe", zips: "74032" },
    { name: "Yale", zips: "74085" },
    { name: "Pawnee", zips: "74058" },
    { name: "Perkins", zips: "74059" },
    { name: "Langston", zips: "73050" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent OSU and North Central Oklahoma departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "OSU & Payne County", desc: "Serving Stillwater, Perry, Cushing, Ponca City, and North Central Oklahoma" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Oklahoma City, OK", route: "/cities/oklahoma-city" },
    { name: "Fast passport renewal in Tulsa, OK", route: "/cities/tulsa" },
    { name: "Emergency passport help in Edmond, OK", route: "/cities/edmond" },
    { name: "Urgent passport services in Norman, OK", route: "/cities/norman" },
    { name: "Same-day passport help in Dallas, TX", route: "/cities/dallas" },
    { name: "Passport courier services in Broken Arrow, OK", route: "/cities/broken-arrow" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Stillwater remotely via secure courier. We do not have a walk-in office in Stillwater — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Payne County and North Central Oklahoma.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Payne County and the North Central Oklahoma region including Noble, Kay, and Pawnee counties",
  serviceAreaIntro: "From the historic Edmon Low Library on the OSU campus and game-day energy at Boone Pickens Stadium to the oil-rich communities of Cushing and Ponca City, from the territorial charm of Guthrie and Perry to the agricultural towns of Perkins and Yale, from the wild horse country of Pawnee to the historic Black towns of Langston — Fast Passport Center serves the entire North Central Oklahoma region. We regularly help OSU students studying abroad, faculty, and local travelers get their passports fast without the 290-mile drive to Dallas.",
  nearbyCitiesIntro: "We serve all Stillwater neighborhoods and the surrounding North Central Oklahoma area including Perry, Cushing, Ponca City, Guthrie, Edmond, and Oklahoma City. If you are anywhere in Payne County, Noble County, or Kay County, we have you covered.",
  howItWorksIntro: "Most Stillwater travelers complete everything online and ship documents overnight. No need to drive to Dallas or wait in line at the regional agency.",
  mistakesIntro: "Stillwater travelers often face a 4.5-hour drive to the nearest regional passport agency in Dallas. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Stillwater Cowboys and North Central Oklahoma travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Stillwater? Here are the most common ones we hear from OSU and Payne County travelers.",
  statePageRoute: "/states/oklahoma",
  statePageName: "Oklahoma",
  dmvWebsite: "https://oklahoma.gov/dps.html",
  dmvLabel: "Oklahoma DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Stillwater travelers with immediate departure needs — as fast as 24 hours for study abroad or urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Stillwater travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Stillwater with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance for Stillwater and OSU students with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Megan S.",
      location: "Stillwater, OK",
      rating: 5,
      text: "OSU study abroad to Spain was 8 days away when I realized my passport was expired. Fast Passport Center got my renewal in 36 hours. I made my flight! Go Pokes!",
      service: "Passport Renewal",
    },
    {
      name: "Dr. Alan K.",
      location: "Stillwater, OK",
      rating: 5,
      text: "Conference in Singapore booked last minute. Fast Passport Center had my passport in 2 days. The dedicated agent was fantastic. Saved my research presentation.",
      service: "Emergency Passport",
    },
    {
      name: "Linda R.",
      location: "Ponca City, OK",
      rating: 5,
      text: "Family trip to Ireland for our 30th anniversary. Fast Passport Center handled everything — our whole family's passports in 4 days. Amazing for North Central Oklahoma.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "stillwater-ok-1",
      name: "Stillwater Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "809 S Lewis St",
      city: "Stillwater",
      state: "OK",
      zip: "74074",
      phone: "(405) 372-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Stillwater",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Stillwater facility. Appointments strongly recommended. Convenient for OSU students.",
      icon: "ri-mail-line",
    },
    {
      id: "stillwater-ok-2",
      name: "Payne County Court Clerk",
      type: "County Court Clerk Passport Acceptance",
      address: "606 S Husband St, Suite 205",
      city: "Stillwater",
      state: "OK",
      zip: "74074",
      phone: "(405) 372-4774",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Stillwater Courthouse",
      website: "https://www.paynecounty.org",
      websiteLabel: "Payne County Court Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "stillwater-ok-3",
      name: "Ponca City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "402 E Grand Ave",
      city: "Ponca City",
      state: "OK",
      zip: "74601",
      phone: "(580) 762-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles north of Stillwater",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kay County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "stillwater-ok-4",
      name: "Guthrie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 W Oklahoma Ave",
      city: "Guthrie",
      state: "OK",
      zip: "73044",
      phone: "(405) 282-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles south of Stillwater",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Historic downtown Guthrie. Serves Logan County.",
      icon: "ri-mail-line",
    },
    {
      id: "stillwater-ok-5",
      name: "Cushing Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "117 S Thompson Ave",
      city: "Cushing",
      state: "OK",
      zip: "74023",
      phone: "(918) 225-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles east of Stillwater",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the Cushing oil hub community. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Dallas", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Stillwater photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Payne County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Stillwater applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Dallas regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many OSU student families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Stillwater travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Stillwater." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Stillwater address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Stillwater before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Stillwater for travelers with urgent international flights or study abroad deadlines. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5-hour drive to Dallas." },
    { q: "How fast can I renew my passport in Stillwater?", a: "Fast Passport Center offers fast passport renewal in Stillwater in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Stillwater?", a: "The nearest regional passport agency to Stillwater is the Dallas Passport Agency, approximately 290 miles south via I-35. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Stillwater without any in-person agency visit required." },
    { q: "Can OSU students get expedited passports for study abroad?", a: "Absolutely. Fast Passport Center helps OSU students get expedited passports for study abroad programs. We understand tight academic timelines and can process passports in 24–48 hours for last-minute study abroad departures to Spain, Germany, China, and other destinations." },
    { q: "Do you serve the entire North Central Oklahoma region?", a: "Absolutely. Fast Passport Center serves the entire North Central Oklahoma region including Stillwater, Perry, Cushing, Ponca City, Guthrie, and surrounding areas. Our courier service works seamlessly from any address in Payne County, Noble County, or Kay County." },
    { q: "Can I expedite a child passport in Stillwater?", a: "Yes. Fast Passport Center expedites child passports in Stillwater for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk North Central Oklahoma families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Stillwater with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Dallas Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Stillwater", address: "4545 W 6th Ave, Stillwater, OK 74074", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Stillwater", address: "2222 N Perkins Rd, Stillwater, OK 74075", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Ponca City", address: "3250 N 14th St, Ponca City, OK 74601", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Guthrie", address: "100 N Division St, Guthrie, OK 73044", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Oklahoma DPS — Stillwater",
      address: "3000 N Perkins Rd, Stillwater, OK 74075",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended. Close to OSU campus.",
      featured: true,
    },
    {
      name: "Oklahoma DPS — Ponca City",
      address: "400 E Central Ave, Ponca City, OK 74601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Kay County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Oklahoma DPS — Guthrie",
      address: "200 N Division St, Guthrie, OK 73044",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Logan County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWO",
      name: "Stillwater Regional Airport",
      distance: "3 miles northwest of downtown Stillwater",
      address: "2020 W Airport Rd, Stillwater, OK 74075",
      note: "Regional airport with daily flights to Dallas/Fort Worth via American Eagle. About 5 minutes from OSU campus.",
      flightUrl: "https://stillwaterok.gov/airport",
      flightLabel: "SWO Airport",
      featured: true,
    },
    {
      code: "OKC",
      name: "Will Rogers World Airport",
      distance: "65 miles south of Stillwater",
      address: "7100 Terminal Dr, Oklahoma City, OK 73159",
      note: "Major Oklahoma airport with direct flights nationwide. About 1 hour 10 minutes from Stillwater via I-35.",
      flightUrl: "https://flyokc.com/",
      flightLabel: "OKC Airport",
      featured: false,
    },
    {
      code: "TUL",
      name: "Tulsa International Airport",
      distance: "80 miles east of Stillwater",
      address: "7777 E Apache St, Tulsa, OK 74115",
      note: "Regional hub with direct flights to major cities. About 1 hour 20 minutes from Stillwater.",
      flightUrl: "https://www.tulsaairports.com/",
      flightLabel: "TUL Airport",
      featured: false,
    },
  ],
};